import { ProductOption } from "@lib/swell/storefront-data-hooks/src/types"

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ")
}

export interface TextFieldProps {
  options?: Readonly<Array<string | undefined>>
  onChange: any
  selected: boolean
  option: ProductOption
}

const TextField: React.FC<TextFieldProps> = ({ onChange, selected, option }) => {
  const { name, description } = option

  return (
    <div>
      <label htmlFor="email-address" className="block text-sm font-medium text-gray-700">
        {name}
      </label>
      <div className="mt-1">
        <input
          type="text"
          name={name}
          onChange={onChange}
          className="block w-full border-gray-300 rounded-md shadow-xs focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
        />
      </div>
    </div>
  )
}

export default TextField
